// components/BatchTables/JobListTable.jsx
import React from "react";
import {
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Box,
  Pagination,
  CircularProgress 
} from "@mui/material";

const ExecDtlTable = ({
  searchQueryExec,
  setSearchQueryExec,
  rowsPerPageExec,
  handleChangeRowsPerPageExec,
  anchorEl,
  closeFilter,
  filters,
  setFilters,
  filteredJobsExec,
  paginatedProcessesExec,
  handleJobClickExec,
  totalPagesExec,
  pageExec,
  handleChangePageExec,
  handleBackExec,
  loading,
  selectedJob
}) => {
  return (
    <>
      <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
        Job Instances for Job:   {selectedJob}
      </Typography>

      <TextField
        size="small"
        label="Search"
        value={searchQueryExec}
        onChange={(e) => setSearchQueryExec(e.target.value)}
        sx={{ flex: 1, mr: 2 }}
      />

      <div style={{ display: "flex", alignItems: "center", margin: "20px 0" }}>
        <Typography variant="body1">Rows per page:</Typography>
        <FormControl size="small">
          <Select value={rowsPerPageExec} onChange={handleChangeRowsPerPageExec}>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
      </div>


      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Job ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Job Instance</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Job Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Start date</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Start Time</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Job Execution Duration</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Exit Code</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
							<TableRow>
								<TableCell colSpan={8} align="center">
									<Box display="flex" alignItems="center" justifyContent="center" p={3}>
										<Typography variant="body2" mr={2}>Loading...</Typography>
										<CircularProgress size={24} />
									</Box>
								</TableCell>
							</TableRow>
						) :filteredJobsExec.length > 0 ? (
              paginatedProcessesExec.map((job, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography
                      variant="body2"
                      onClick={() => handleJobClickExec(job.runNum, job.batchId)}
                      sx={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                    >
                      {job.runNum}
                    </Typography>
                  </TableCell>
                  <TableCell>{job.batchId}</TableCell>
                  <TableCell>{job.batchName}</TableCell>
                  <TableCell>{job.lastExecDate}</TableCell>
                  <TableCell>{job.lastExecStart}</TableCell>
                  <TableCell>{job.astExecDuration}</TableCell>
                  <TableCell>{job.lastExecStts}</TableCell>
                  <TableCell>{job.lastRunStts}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ fontWeight: "bold" }}>
                  No results found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="right" mt={3}>
        <Pagination
          count={totalPagesExec}
          page={pageExec}
          onChange={handleChangePageExec}
          color="primary"
          showFirstButton
          showLastButton
        />
      </Box>
        <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="outlined" color="primary" onClick={handleBackExec}>
          Back
        </Button>
      </Box>
    </>
  );
};

export default ExecDtlTable;
